import { render, staticRenderFns } from "./business-list-table.vue?vue&type=template&id=51d15c1e&"
import script from "./business-list-table.vue?vue&type=script&lang=js&"
export * from "./business-list-table.vue?vue&type=script&lang=js&"
import style0 from "./business-list-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./business-list-table.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)
import block1 from "./business-list-table.vue?vue&type=custom&index=1&blockType=graphql"
if (typeof block1 === 'function') block1(component)

export default component.exports